import { render } from "./RecommendProperties.vue?vue&type=template&id=44452935"
import script from "./RecommendProperties.vue?vue&type=script&lang=js"
export * from "./RecommendProperties.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__